import { DealerFeatureCollection } from "./Types";


// In dev, this relative path is proxied to https://dev.keapi.dev by Vite (see vite.config.ts).
// In a production build, requests go directly to the deployed backend.


export class DealersClient {

	private async fetch<T>(params: Record<string, string | number | undefined>): Promise<T> {
		const query = new URLSearchParams();
		for (const [key, value] of Object.entries(params)) {
			if (value !== undefined) {
				query.set(key, String(value));
			}
		}
		const response = await fetch(`${import.meta.env.VITE_API_BASE}/dealers?${query}`);
		if (!response.ok) {
			throw new Error(`HTTP ${response.status}: ${response.statusText}`);
		}
		return response.json() as Promise<T>;
	}

	async getByCountry(country: string) {
		return (await this.fetch<DealerFeatureCollection>({ country })).features
	}

	async getByBoundsAndCountry(
		country: string,
		north: number,
		east: number,
		south: number,
		west: number,
	) {
		return (await this.fetch<DealerFeatureCollection>({ country, north, east, south, west })).features;
	}
}

export const dealersClient = new DealersClient();